export default "__VITE_ASSET__DzjxwflJ__"